import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  public siteKey = environment.reCatchSiteKey;
  // @ViewChild('captchaElem') captchaElem;
  public feedbackForm;
  public isSubmitted = false;
  public isError = false;
  public feedSuccess = '';
  public feedError = '';
  constructor(private _api: ApiService) { }

  ngOnInit() {
    this.createForm();
  }
  private createForm() {
    this.feedbackForm = new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3)])),
      email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
      note: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(120)])),
      recaptcha: new FormControl('', Validators.compose([Validators.required]))
    });
  }
  get formControls() { return this.feedbackForm.controls; }

  sendFeedback() {
    console.log(this.feedbackForm.valid, this.feedbackForm.value, this.feedbackForm.invalid);
    this.isSubmitted = true;
    this.feedSuccess = '';
    this.feedError = '';
    if (this.feedbackForm.invalid) {
      return;
    }
    console.log(this.feedbackForm.valid, this.feedbackForm.value);
    //return;
    if (this.feedbackForm.valid) {
      console.log('submit');
      this._api.submitFeedback(this.feedbackForm.value).subscribe((response) => {
        console.log(response);
        this.isSubmitted = false;
        this.feedbackForm.reset();
        if (response === 'Feedback Submitted Successfully') {
          this.feedError = '';
          this.feedSuccess = 'Thank you for your feedback! We will look into it.';
        } else {
          this.feedSuccess = '';
          this.feedError = 'Error occured while sending email. Please try again later.';
        }
      }, (err) => {
        console.log('error', err);
        this.feedSuccess = '';
        this.feedError = 'Error occured while sending email. Please try again later.';
      });
    }
  }

  handleSuccess(e) {
    console.log('reCaptcha Response', e);
  }
  handleLoad() {
    console.log('reCaptcha Loaded');
  }

  handleReset() {
    console.log('reCaptcha Reset');
  }

  handleExpire() {
    console.log('reCaptcha Expired');
  }
}
